// extracted by mini-css-extract-plugin
export default {"container":"mu4ya","image":"DMQUH"};